/** Auto-generated API error strings (DE). */
export const apiErrorMessagesDe = {
  "E_00290c73141977ca": "Der letzte aktive Admin kann nicht gelöscht werden",
  "E_003d11511f512a4d": "personId fehlt",
  "E_006c2ba0c8165076": "Nur m1connect-Untergeräte sind für Personen-Medien erlaubt",
  "E_0094eafa468d5869": "Ungültige Sprache (nur 'de' oder 'en')",
  "E_010aa340deb365d4": "Ungültiger Zahlungsart-Typ",
  "E_01b2fb5d6cf59bd2": "Eine Abschlussphase kann nicht die Startphase sein",
  "E_01e0d7a4c490a2f8": "pipelineId erforderlich",
  "E_0249c6e0a3d1b702": "Für diesen Mandant läuft ein Datenimport. Anmeldung ist vorübergehend nicht möglich.",
  "E_027b87bbe3048a7a": "Ungültige Kategorie. Erlaubt: inbox/outbox",
  "E_02d5f916f30e69aa": "Mandant kann nicht gelöscht werden: Es existieren noch Studios",
  "E_03bd8887e76cafe4": "Lesegerät für Untergerät nicht gefunden",
  "E_03dc6b2c881577bc": "Wertekonto nicht gefunden",
  "E_062488517a9e3b13": "Body ist erforderlich",
  "E_0697e28990fc9609": "Bei einmaliger Abrechnung muss das Beginndatum dem Vertragsstart entsprechen.",
  "E_0773ad55cabb447e": "Name ist erforderlich.",
  "E_09207bbaa591bf03": "Pipeline kann nicht aktiviert werden: Endphasen ohne Folgephasen benötigen zugeordnete Abschlussgründe",
  "E_09ccc29459dcb0a8": "Diese SEPA-Gruppe wird noch von Wertekonten verwendet und kann nicht gelöscht werden.",
  "E_0aa725723d664a60": "Ungültige Aufbewahrung (60-525600 Minuten)",
  "E_0ae3949cce11e264": "Kein Zugriff auf ein ausgewähltes Studio",
  "E_0afcb5f3bbdd8fa3": "Betreff ist erforderlich.",
  "E_0bda4ec6d1f91376": "DefaultValidValue ungültig",
  "E_0c1452ba74310263": "Leadquelle wird noch verwendet und kann nicht gelöscht werden",
  "E_0c7d1b2746bc9262": "Löschen nicht möglich: Für dieses Wertekonto wurden bereits Buchungen (Auf-/Abbuchungen) vorgenommen. Es darf nur gelöscht werden, wenn ausschließlich die Erstaufladung erfolgt ist.",
  "E_0cd6c9e49b02d97f": "Benutzername fehlt",
  "E_0d0222e71f5bb486": "Id bereits vergeben",
  "E_0d245daf616d6505": "Person not found",
  "E_0d3a4db6218d9798": "Abschluss-Szenario nicht gefunden",
  "E_0d4bd559fc46ea71": "E-Mail required",
  "E_0df620e9d663742c": "Keine Vertragsbausteine mit SEPA-Gruppen gefunden. Bitte weisen Sie Vertragsbausteinen SEPA-Gruppen zu.",
  "E_0e5b29544fcbd106": "Name zu lang (max 160 Zeichen)",
  "E_0e621e130261aad7": "Löschen nicht möglich: Für diesen Vertrag sind Beiträge bereits in einem SEPA-Lastschriftlauf vorgemerkt.",
  "E_0e655d86cf102671": "Dokument hat keine Datei.",
  "E_0eaa91a6b089896a": "Vorschau konnte nicht erzeugt werden.",
  "E_0ff3bbcae02f4285": "MediumId already exists",
  "E_1001025af5cff872": "Nur M1Access-RQR Geräte unterstützen diese Funktion.",
  "E_10923a23fadef71c": "Wert muss > 0 sein",
  "E_10b5586e5048b5fd": "Notiztext ist erforderlich.",
  "E_11104d1d9de41f2f": "Abschlussgrund wird noch verwendet und kann nicht gelöscht werden — stattdessen deaktivieren",
  "E_115552bd01c7d2e4": "SEPA-Lastschrift aktivieren nicht möglich: Gläubiger-ID fehlt (Stammdaten → Bank).",
  "E_1174f2c62ec38449": "Bankverbindung und offene Position sind erforderlich.",
  "E_119d6bfd1e73d7b0": "Vertragsbaustein-Vorlage nicht gefunden",
  "E_1410d0adcb44b8d9": "Beitrag wurde bereits bezahlt und kann nicht storniert werden",
  "E_14d539c281ca3717": "Datenbank-Schema nicht aktuell (BankData-Spalten fehlen)",
  "E_1679d25786a44be8": "Mahnung dieser Stufe wurde bereits für diesen Posten versendet",
  "E_16fc5ee871a85f9e": "Message is required",
  "E_190e26a000cb2315": "ToEmail ist erforderlich",
  "E_19c28626353c2040": "Kein Mandant-Kontext.",
  "E_1a492987d6c70626": "Studio kann nicht gelöscht werden, da noch Abhängigkeiten existieren: ",
  "E_1affe3946cbe34af": "Löschen nicht möglich: Für den zugehörigen Vertrag wurden bereits Zahlungen verbucht.",
  "E_1b31635518bc9fa5": "Unsupported country code.",
  "E_1b64c4b2922a28be": "Name ist erforderlich",
  "E_1c3aba58712247c7": "Vergangene Termine können nicht storniert werden",
  "E_1ca3c66ee12cacdc": "Anzahl Raten muss zwischen 2 und 24 liegen",
  "E_1cebdd7f6850b326": "Wertekonto-Vorlage kann nicht deaktiviert werden, solange sie in Vertragsvorlagen oder aktiven Kunden-Wertekonten verwendet wird.",
  "E_1d07eed3bb2bba44": "Bank nicht gefunden",
  "E_1d344c380b46aff1": "Kürzel ist erforderlich",
  "E_1d5c5bd1a7d7e682": "Für dieses Abschluss-Ergebnis ist in der Pipeline bereits eine Abschlussphase hinterlegt",
  "E_1dc3ee3afda5dbf1": "Mindestruhezeit darf nicht negativ sein",
  "E_1e155fa8399d7563": "Ungültiges Bild",
  "E_1ed3f6269fee21f6": "Untergerät nicht gefunden",
  "E_1f1847c7382c7707": "Termingruppe für Phase nicht gefunden",
  "E_1ffd77937ab16bf5": "Entweder SFDT oder HTML-Inhalt ist erforderlich",
  "E_2019d0897ceab3e7": "Zielbenutzer nicht gefunden",
  "E_216fcc0e92c6bda6": "Ungültiges Zahlungsdatum.",
  "E_23448b2d00bd538b": "Ziel-Phase nicht gefunden",
  "E_236ed707447b69c3": "Sprachänderung erfordert Bestätigung (ConfirmLanguageChange: true)",
  "E_240783b70fd84f27": "Ungültige Auflösung (1-1440 Minuten)",
  "E_2418dff1fc4b6e3f": "Keine Beiträge gefunden, die für SEPA-Lastschrift geeignet sind. Bitte prüfen Sie die Filtereinstellungen.",
  "E_242a762ecfad4434": "TenantId im Body muss mit dem Kontext-Mandanten (X-Import-Context-Tenant-Id) übereinstimmen.",
  "E_24932d9b61211e9b": "Amount must be > 0",
  "E_255c550512010e25": "Passwort zu kurz (min. 8)",
  "E_25619050eddb966c": "Kein Zugriff auf dieses Studio",
  "E_2574fb69a9c2bea9": "Host ist erforderlich",
  "E_25ade855a2519d12": "Bild zu groß (max 8MB)",
  "E_26ad147724ea4663": "Eine Person mit dieser E-Mail-Adresse existiert bereits.",
  "E_276bc4859378f888": "Benutzer nicht gefunden",
  "E_27cc907c89d2462b": "Eine oder mehrere ausgewählte SEPA-Gruppen wurden nicht gefunden oder sind inaktiv.",
  "E_27f4537d40ab57db": "PDF-Konvertierung ergab leeres Dokument",
  "E_28f0a486fd04ace2": "Lead hat keine aktuelle Phase",
  "E_2a7a229c07d51ade": "Wertekonto-Vorlage nicht gefunden",
  "E_2b2ba0a0570c72cb": "Löschen nicht möglich: Für diesen Vertrag sind Beiträge bereits in einem SEPA-Lastschriftlauf eingereicht.",
  "E_2bc471ef355bec11": "Der primäre Administrator-Account muss eine E-Mail-Adresse haben.",
  "E_2bf9947267d059a9": "Mahnstufe ist nicht aktiv",
  "E_2f4a7e01a377afcb": "Key fehlt",
  "E_302fd696807ca214": "Rabatt nicht gefunden oder inaktiv",
  "E_304e7ef575e76bad": "Eine oder mehrere Textvorlagen sind inaktiv.",
  "E_30d2c4205ce7726a": "Kürzel nicht gefunden oder Account inaktiv",
  "E_313c8c2e6c092694": "Standard-Konto kann nicht gelöscht werden",
  "E_334c7eb6c9dab29c": "Terminart wird noch verwendet und kann nicht gelöscht werden",
  "E_343bc6f7a524aea4": "Rabatt wird noch in Verträgen verwendet und kann nicht gelöscht werden",
  "E_3548de84dbf66d51": "Ungültiges Abschluss-Ergebnis für die Abschlussphase",
  "E_36212ce227eaeaf0": "Verwendungszweck für mehrere Verträge ist erforderlich",
  "E_367cc751ce2808a1": "Kürzel ist erforderlich.",
  "E_36abdcf63e8c854a": "Vorlage existiert bereits (Key/Channel muss eindeutig sein).",
  "E_3814a55a401197cc": "Ungültige BIC",
  "E_386f6180508833e2": "LeadIds erforderlich",
  "E_38b3f36ca1b65602": "Ungültige Benachrichtigungsvorlage",
  "E_38b48de99beb5740": "Studio ist erforderlich",
  "E_38dff597b48a07e8": "Quellbenutzer nicht gefunden oder kein Zugriff.",
  "E_3960dcc42d7d6fe0": "Alle gewählten Terminarten müssen zum Standardkalender gehören.",
  "E_3980b06bd5764bd4": "Kein Studio gefunden.",
  "E_39f63883ea63d618": "Host fehlt",
  "E_3a22cb4c28cb5e8e": "Mindestens ein Zielbenutzer erforderlich.",
  "E_3ac150585b6c467c": "Die Vorlage wird von mindestens einer Vertragspaket-Vorlage als Vertragsdokument verwendet und kann nicht gelöscht werden.",
  "E_3ae02b8c3c9e307a": "MediumId too long",
  "E_3aeda8668f35017c": "Rolle wird noch von Benutzern verwendet",
  "E_3af1e1869e85218a": "Nicht angemeldet",
  "E_3b437a08bb1ef759": "Ungültige BLZ (muss 8-stellig sein)",
  "E_3bd3a5d851d5a88c": "Prozentualer Rabatt darf nicht über 100% liegen",
  "E_3cf9634a6f250449": "Empfang ist deaktiviert",
  "E_3e5426c611ae2bc1": "Another scope already uses \\",
  "E_3e9e645ebbfffa9b": "Standardkalender nicht gefunden",
  "E_400175e487c3f436": "Mindestens ein Verwendungszweck muss ausgewählt sein",
  "E_40b79681e0058032": "Kein Zugriff auf diese Ressource",
  "E_40bbed40641d1db4": "QR-Code gehört nicht zu diesem Lesegerät",
  "E_40cc2414ec624a7d": "Terminart nicht gefunden oder inaktiv",
  "E_414221d3e7b64529": "Beitrag ist bereits für SEPA-Lastschrift vorgemerkt und kann nicht manuell bezahlt werden",
  "E_4147e0e422172de1": "Kopiervorlage nicht gefunden.",
  "E_433c5465104ff8e0": "FromEmail ist erforderlich",
  "E_436602849325f05b": "SEPA-Datei wurde noch nicht generiert",
  "E_43e35c1f95c61160": "Channel fehlt",
  "E_44ed4de7362fe29b": "Mindestruhezeit-Einheit ist erforderlich, wenn ein Wert angegeben ist",
  "E_452db19b0b390c9b": "Host/Port fehlen",
  "E_456281642b64af3f": "DOCX konnte nicht geladen werden",
  "E_45f442b0d02795b8": "Pattern zu lang (max 80 Zeichen)",
  "E_464ed8e119420c9b": "User nicht identifiziert.",
  "E_46e8d653316e0ace": "Mindestens eine Aktion (CheckIn, CheckOut, OpenDoor, UnlockDevice, DeductPoints) muss aktiviert sein",
  "E_4750331a68713e90": "Lead ist nicht abgeschlossen und kann nicht wieder geöffnet werden",
  "E_49758cd434505718": "Open item is already in a SEPA direct debit run",
  "E_49d54ba36f1d37cd": "Löschen nicht möglich: Für dieses Vertragspaket wurden bereits Zahlungen verbucht.",
  "E_4b39dad91f843083": "Zahlungsart 'sepa' ist nicht definiert (Zahlungsarten anlegen/seed-defaults ausführen).",
  "E_4b92ce614d70fbd2": "Wenn keine Laufzeit definiert ist, darf auch keine Verlängerung definiert werden.",
  "E_4c5c2b5e1e7b6b4a": "Die Rolle des primären Administrator-Accounts kann nicht geändert werden.",
  "E_4ce42ab9de75052b": "Leadquelle nicht gefunden",
  "E_4d657d6b67e4de06": "Template nicht gefunden",
  "E_4dd8077d33ce97c5": "Wertekonto-Vorlage nicht gefunden oder nicht aktiv",
  "E_4e60e7977f3e7da3": "Ungültige Kalenderansicht (nur 'today', 'week', 'month' oder 'list')",
  "E_4eb48584fe966f39": "Keine ausgehende E-Mail-Konfiguration (global oder pro Studio) vorhanden",
  "E_502512bb4f5a1a8c": "Gelesene UID ist ungültig",
  "E_50e928094213f472": "Vertragsbaustein-Vorlage kann nicht deaktiviert werden, solange sie in Vertragspaket-Vorlagen oder aktiven Vertragsbausteinen verwendet wird.",
  "E_517330031d68eb60": "Ratenzahlungsmodell ist nicht aktiv",
  "E_530cecc8b83d6b5a": "Bei mehreren QR-Codes muss einer ausgewählt werden",
  "E_533564ff1a9b4d2f": "Ungültiges JSON-Format für LoginDefaultTheme",
  "E_537c24bc3f21c2bd": "Anzahl Wochenbeiträge darf nicht negativ sein",
  "E_53850b6dff468b93": "Der gewählte Mandant ist nicht als Kopiervorlage markiert.",
  "E_541130147585af22": "Rundung: Schritt muss > 0 sein",
  "E_54fb1991c8a5cdf1": "Kürzel fehlt",
  "E_552db8ead9a1dd15": "Ratenzahlungsmodell nicht gefunden",
  "E_55b75910cbe54e6e": "Name ist bereits vergeben",
  "E_560c94d62249410d": "Keine Personen in den ausgewählten SEPA-Gruppen gefunden. Bitte prüfen Sie, ob Vertragsbausteinen diesen Gruppen zugewiesen sind.",
  "E_56184d324e64a04d": "Lastschriftlauf ist bereits storniert",
  "E_56de8ce54aeb4f9b": "Ein oder mehrere Studios wurden nicht gefunden",
  "E_56fbe1c966f9d4dc": "Externe Buchungs-ID (z. B. End-to-End-Referenz) ist für die Verbuchung erforderlich.",
  "E_57261b6ec1458b8a": "FromEmail ist erforderlich (für Test-E-Mail)",
  "E_57f7e56b3fa7381d": "Benutzername ist erforderlich",
  "E_5804a9de94daeaa3": "Ende muss nach Start liegen",
  "E_585bfa7b39a762ca": "Ungültiges Bildformat",
  "E_58c6f923878c3f8f": "Preferences zu groß (max. 100KB)",
  "E_59aec492a8c3d70c": "Kürzel darf max. 20 Zeichen haben.",
  "E_5a47918a113ca5db": "Quellbenutzer fehlt.",
  "E_5b85cdf9c05ffd82": "Lead hat keine E-Mail-Adresse.",
  "E_5ce43698cefd8b8d": "Mandant kann nicht gelöscht werden: Es existieren noch Personen",
  "E_5d008bb211b97550": "Ausführungsdatum darf nicht in der Vergangenheit liegen",
  "E_5ef6f3107098c49f": "Rückwirkende Rabatte sind nicht erlaubt.",
  "E_5eff1492b31fdb5e": "Lead nicht gefunden",
  "E_5f61b2201a6964fe": "Vertragspaket ist bereits beendet",
  "E_5f94504269e2c74d": "Rolle mit diesem Namen existiert bereits",
  "E_604db0928fda2bca": "Ein oder mehrere Studios wurden nicht gefunden.",
  "E_63338232da51480c": "Firmenname ist erforderlich",
  "E_6370643ae30eaac5": "Kategorie nicht gefunden",
  "E_639d7abc20d2783d": "Kündigungsgrund wird noch verwendet und kann nicht gelöscht werden",
  "E_64f5557b1dde530c": "Ungültige Quellbenutzer-ID.",
  "E_65ae50e2782f7af5": "Zuordnung existiert bereits",
  "E_66b5ffc955768ad0": "Nur .zip-Dateien werden unterstützt.",
  "E_66e77f4878f4e08c": "DayOfWeek muss zwischen 0 (Sonntag) und 6 (Samstag) liegen",
  "E_67bd7119b5444a17": "Keine Berechtigung für diese Person",
  "E_686e59aae40815e2": "Bezeichnung ist erforderlich",
  "E_6993192fe37700db": "Konto wird noch verwendet und kann nicht gelöscht werden",
  "E_699e95fecce6e212": "Für diesen offenen Posten existiert bereits eine Ratenzahlung",
  "E_6a278a8d052c4da5": "Betreff ist erforderlich",
  "E_6a97229ffde1297d": "Titel fehlt",
  "E_6b4b36db674eac1b": "Kündigungsfrist für Erstlaufzeit darf nicht negativ sein",
  "E_6ba0177d582a4098": "USt-Einstellung wird noch verwendet und kann nicht gelöscht werden",
  "E_6bd50c2a3a6bd5c8": "Entweder ResourceId oder PersonId muss angegeben werden",
  "E_6ccdb37b039b3c54": "Offene Position nicht gefunden.",
  "E_6cead504589b5f49": "Der letzte aktive Administrator kann nicht gelöscht werden",
  "E_6e8241e66468971d": "Lesegerät nicht gefunden",
  "E_6f1043decc50d2ad": "PDF-Konvertierung fehlgeschlagen: WordDocument ist null",
  "E_6f2355cb03723ff5": "Es muss mindestens ein aktiver Plattform-Administrator existieren.",
  "E_6ff4b43e085082c5": "USt-Einstellung nicht gefunden",
  "E_706b6fbcf2e20dd2": "Price must be >= 0",
  "E_709546232ee21f01": "Nur im Admin-Modus verfügbar",
  "E_70b704d952c2a8b3": "DOCX enthält keine Sections",
  "E_70bbb3be9c5b45d4": "Ungültige pain-Version (nicht zulässig)",
  "E_715f90ea3b07a304": "Aktuelles Passwort ist falsch",
  "E_71ebaa6473865851": "Endzeit muss nach Startzeit liegen",
  "E_722881a953c6de54": "Body is required",
  "E_73e5238b97f3a8be": "Bitte eine ZIP-Datei hochladen.",
  "E_74bd9472377f0e90": "Eine andere Zahlungsart mit diesem Typ existiert bereits.",
  "E_75440065586f6af2": "Ungültige Preferences (muss ein JSON-Objekt sein)",
  "E_76729adcb7aaaa1f": "Bei eingeschränkter Auswahl mindestens ein Modul wählen.",
  "E_7691639784e9a897": "E-Mail bereits vergeben",
  "E_7692089d19658aa0": "Session fehlt",
  "E_76c32297e8481104": "Kein Studio gefunden",
  "E_7840cf6ee3995c80": "ToEmail ist erforderlich (für Test-E-Mail)",
  "E_792a3026f85bee41": "Unbekannte WalletProductIds: ",
  "E_79edc4db8acdef0f": "Vertragsbaustein nicht gefunden",
  "E_7a10035a88605951": "Der Termin liegt zu nah an der aktuellen Zeit (Mindestvorlauf für Mitarbeiter-Buchung).",
  "E_7a5934f8267e2c24": "Täglich ist aktuell nicht unterstützt",
  "E_7b06c8b6e09c3390": "Betrag muss größer als 0 sein.",
  "E_7b1fc4dec9cec70c": "Betrag muss größer als 0 sein",
  "E_7b88cdc2297792f7": "Hardware-Gerät gehört nicht zu diesem Lesegerät",
  "E_7ba0ef9a9b6ee1dc": "SourceRelationsJson ist kein gültiges JSON.",
  "E_7c4afa0313deb25a": "Abschlussgrund ist noch Phasen zugeordnet — zuerst die Zuordnung in der Pipeline-Verwaltung entfernen",
  "E_7d92a90726dcb3c0": "Datenbankfehler beim Speichern. Bitte prüfen, ob alle Migrationen ausgeführt wurden (dotnet ef database update). ",
  "E_7fbe34f6266de74f": "Mahnstufe wird noch von Mahnungen verwendet und kann nicht gelöscht werden",
  "E_8045c2a93979fcac": "E-Mail-Konto nicht gefunden",
  "E_8115cee0c705a42f": "PersonId fehlt",
  "E_81fd4a914d687c7a": "StartHour und EndHour müssen zwischen 0 und 23 liegen",
  "E_83521788d5852897": "Bankverbindung wurde nicht gefunden oder ist inaktiv",
  "E_83e13baf0284a6bb": "Steuersatz muss zwischen 0 und 100 liegen",
  "E_85228b884830f06f": "Vorname zu lang",
  "E_856b4a13316d2444": "SEPA-Lastschrift: Gläubiger-ID ist erforderlich (Stammdaten → Bank oder Bankverbindung).",
  "E_85b7af4631b10d8c": "SEPA-Gruppe ist erforderlich",
  "E_85c993614d0df598": "Widerrufsfrist darf nicht negativ sein",
  "E_86388981fa746da9": "Mindestens ein Studio wurde nicht gefunden oder ist inaktiv",
  "E_863ababc12010ea8": "Name erforderlich",
  "E_8674964644d4bfd3": "Fehler beim Laden der Vorlagen",
  "E_87509e699381b71a": "Mandant kann nicht gelöscht werden: Es existieren noch Verträge",
  "E_8847fc41f91da9b3": "Person-Ressourcen haben immer Kapazität 1",
  "E_884c042a99a14310": "Abschlussgrund ist in diesem Phasenmodell nicht konfiguriert",
  "E_887b52b7617c73b1": "Löschen nicht möglich: Wertekonto ist einer SEPA-Gruppe zugeordnet.",
  "E_8956779ae997ff5e": "Keine Datei übermittelt",
  "E_8960745740fe2454": "Löschen nicht möglich: Für dieses Wertekonto wurde bereits eine Zahlungsart/Abrechnung hinterlegt.",
  "E_89d103a8d71228a7": "Person nicht gefunden",
  "E_8a341328d8731459": "Startdatum ist erforderlich",
  "E_8ac179b52b96453c": "Ungültiges JSON-Format für PlatformDefaultTheme",
  "E_8bcb64b09f4a4dc4": "DefaultBalance ungültig",
  "E_8c2f35527562c775": "Unbekannte oder inaktive Zahlungsart",
  "E_8dce190ecc56b546": "CompanyName ist erforderlich",
  "E_8e61b93094bb49ce": "User ID und PIN sind erforderlich.",
  "E_8eb9cd77373078e7": "Studio nicht gefunden",
  "E_8ed0dc0f6ad931b9": "Bereits verbuchte Lastschriftläufe können nicht gelöscht werden",
  "E_8ee6ba1ff47f672c": "Globaler Feiertag nicht gefunden",
  "E_8ee9fb26dfe2eca4": "Keine Ressourcen angegeben",
  "E_8f68596b9088df3c": "Ungültige IBAN",
  "E_8faaf6078c50757e": "SEPA-Lastschrift ist deaktiviert",
  "E_90daae4aff9906ac": "Pipeline nicht gefunden",
  "E_91086a5ebc37a24c": "Abschluss-Szenario wird noch verwendet und kann nicht gelöscht werden",
  "E_912cc216b2099d66": "Keine IMAP-Ordner gefunden.",
  "E_913057fe7b0c051c": "Die offene Position ist nicht mehr offen.",
  "E_9141a70659aa9913": "Buchführungskonto nicht gefunden",
  "E_91b00a264e7cb378": "Die Vertragslaufzeit ist bereits abgelaufen; die Kündigung kann nicht zurückgenommen werden.",
  "E_9263fafa8bcaf366": "Keine gültigen Zielbenutzer.",
  "E_947aa92f220bdd01": "Gateway-Einstellungen fehlen! Bitte konfigurieren Sie das Gateway zuerst.",
  "E_955fc577fdbe2a36": "Account nicht gefunden oder inaktiv",
  "E_960f0cec1c2a3720": "Kein Passwort gespeichert",
  "E_96812a67ef1374cc": "Vertragspaket nicht gefunden",
  "E_96c5826f8d2d8af9": "Eine oder mehrere Benutzer wurden nicht gefunden",
  "E_97674dd6183e5e1f": "Aufpreis ungültig",
  "E_97da85112eaf1554": "Admin-Mandant nicht konfigurierbar",
  "E_97f982a95192206d": "Min. Teilnehmer muss >= 1 sein",
  "E_98dae505387edb59": "Die Geräte-Id ist bereits vergeben.",
  "E_9a51c95253f65d9a": "Mindestens eine SEPA-Gruppe wurde nicht gefunden oder ist inaktiv",
  "E_9a6940587dba68ab": "Ungültiger Lesegerättyp",
  "E_9a99d7b908f98fad": "DaysAfterDueDate muss >= 0 sein",
  "E_9abd6961d8a2d1ce": "Nur Stammstudio darf geändert werden (persons.changeHomeStudio).",
  "E_9b36f9f76278fca9": "SMTP-Konfiguration nicht gefunden",
  "E_9bf98382b2bf50db": "IMAP-Konfiguration nicht gefunden",
  "E_9d2e73ad1ca40968": "E-Mail/Username fehlt",
  "E_9ded98c65efac0e7": "EndHour muss nach StartHour liegen",
  "E_9e7d83a9a1ac98c0": "Template-Body nicht gefunden",
  "E_9fbbc4a70c94d3cd": "Inkasso-Dienstleister wird noch in Mahnstufen verwendet",
  "E_a0767fea4746e247": "Nur Postausgang-Dokumente können erneut versendet werden.",
  "E_a132718acfdff53a": "FirstName and LastName required",
  "E_a145295be99e3e66": "Datei zu groß (max 200MB)",
  "E_a1884b23d5ee4665": "Subject ist erforderlich",
  "E_a2449174b02dceef": "Punktwert darf nach Aufbuchung nicht < 0 sein",
  "E_a2848a5e468dba6b": "Ungültiger Vorlauf (1-730 Tage)",
  "E_a3c6ceee8cacc871": "Dieser Abwesenheitsgrund wird noch verwendet und kann nicht gelöscht werden",
  "E_a3e4657292789edd": "Reply only supported for SMS and WhatsApp",
  "E_a49861377e9ce3e0": "Sie können Ihr eigenes Admin-Konto nicht deaktivieren.",
  "E_a7019ceb41e277ee": "Keine ausgehende E-Mail-Adresse konfiguriert.",
  "E_a706d65673ec5c06": "Der E-Mail-Inhalt konnte nicht konvertiert werden. Bitte prüfen Sie das Format der Vorlage.",
  "E_a7711b401a7a6498": "Bezeichnung required",
  "E_a782fb57f1da8be7": "Ungültiger Phasenübergang",
  "E_a81cfb9a57b20b8d": "Die offene Position ist bereits in einem SEPA-Lastschriftlauf.",
  "E_a85f4f261acb8906": "Vertrag nicht gefunden",
  "E_a9b49d746584caf0": "StudioId ist ungültig oder gehört nicht zum Mandanten.",
  "E_abac84f084319496": "Eine Abschlussphase darf keine Folgephasen haben",
  "E_abadef3cd2c9954e": "Versand ist deaktiviert",
  "E_ac1d1fcfc844b532": "Max. Teilnehmer muss >= Min. Teilnehmer sein",
  "E_ac65a2cd062fbcc0": "SEPA-Einstellungen fehlen (Einstellungen → Stammdaten / Bank).",
  "E_ad11b05f1c6d6414": "Mandant-ID 'admin' ist reserviert",
  "E_adbf9e4f40978688": "Abschlussgrund nicht gefunden oder inaktiv",
  "E_adce815c913bfe1f": "Kontonummer ist bereits vergeben",
  "E_af05db96c4036ba4": "Nur CompanyAdmin darf erzwungenes Löschen ausführen.",
  "E_afa332a6f3f56437": "Lesegerät kann nicht gelöscht werden, solange es Vertragsbausteinen oder Wertekonten zugeordnet ist.",
  "E_b05c9d7ff794df86": "Offener Posten gehört nicht zu dieser Person",
  "E_b09c6695d9c968a6": "Dauer muss größer als 0 sein",
  "E_b0d1af01ba074ac6": "Level muss >= 1 sein",
  "E_b0edeef2bcac438f": "Ungültige Zeichen gefunden",
  "E_b15a307b58000dfb": "E-Mail oder Passwort falsch",
  "E_b191a79964c2612c": "Ressource wird noch von Terminarten verwendet und kann nicht gelöscht werden",
  "E_b1b71f44f79a3597": "Ungültiges Format für Registrierungscode (muss 12 Zeichen sein)",
  "E_b3287df1c221c023": "Person ist nicht für SEPA gesperrt.",
  "E_b347db0cc7b83b70": "Vorname oder Nachname erforderlich",
  "E_b49746eae5e42b90": "Verwendungszweck für einzelne Buchung ist erforderlich",
  "E_b61f013db01ba8d9": "A scope for \\",
  "E_b6eb23d898faaab6": "Der Import wurde bereits ausgeführt. Zum erneuten Hochladen einen neuen Importvorgang anlegen oder zuerst zurücksetzen.",
  "E_b7898a5f8e389a7b": "Kein Zugriff auf diese Einstellung",
  "E_b805d956b825f4e5": "Beitrag wurde bereits bezahlt und kann nicht mehr bearbeitet werden",
  "E_b85ad33e10939d31": "Zuständiger Account nicht gefunden oder inaktiv",
  "E_b8741cc7cf8e0bc1": "Fehler beim Laden der Signaturen",
  "E_b8a9e246828d7865": "Tenant missing",
  "E_b8e4fa7e263379b1": "Mindestruhezeit-Wert ist erforderlich, wenn eine Einheit angegeben ist",
  "E_b9618a2eee747b8b": "Eine oder mehrere Textvorlagen sind keine Mahnvorlagen.",
  "E_b96f5ac9cd4a0ea0": "Der primäre Administrator-Account kann nicht gelöscht werden.",
  "E_bac66a09f981a87c": "Mindestens ein Rhythmus ist erforderlich",
  "E_bcb81b26db69cfa8": "Name fehlt",
  "E_bccda8eaedcabc06": "Kein E-Mail-Konto für Versand konfiguriert (Benachrichtigungen).",
  "E_be2f69b4197e5d76": "Gateway-Einstellungen fehlen! Wenden Sie sich an den Softwareanbieter.",
  "E_be48b0d0a9b908c0": "QR-Code nicht gefunden.",
  "E_bf11deb64a855b29": "Dokument konnte nicht geladen werden.",
  "E_c0f66d49ad2e7b3b": "Ressource nicht gefunden",
  "E_c21e8eccfb1d2795": "Probezeit darf nicht negativ sein",
  "E_c2a867d530e945dc": "Alle QR-Codes müssen einen Wert haben.",
  "E_c2ad8338d94fa505": "UserRoleId fehlt",
  "E_c2daa5039c994ae0": "TenantId ist erforderlich (oder Header X-Import-Context-Tenant-Id).",
  "E_c319fa009456a2be": "Rolle nicht gefunden",
  "E_c31d25aaf07346b2": "Alle QR-Codes müssen mindestens eine Aktion haben.",
  "E_c3bd4209911a6305": "Kontonummer fehlt",
  "E_c400ed25e3b44fd9": "Purpose fehlt",
  "E_c423bb4b53b2577d": "Kategorie wird verwendet und kann nicht gelöscht werden.",
  "E_c53436518b63e39f": "Id zu lang",
  "E_c59ef4b12e525e4b": "Firma nicht gefunden",
  "E_c62db2f2d9446c8f": "SchemaJson ist erforderlich.",
  "E_c62f20700bdbe245": "Nur ResourceId ODER PersonId darf angegeben werden, nicht beide",
  "E_c66f39277334c0e2": "Kein Zugriff auf eines der gewählten Studios",
  "E_c6730a34fda174a4": "Ungültiger Mindestabstand (0-86400 Sekunden)",
  "E_c686b2bedfb2980b": "Eine oder mehrere Personen wurden nicht gefunden",
  "E_c75c36079fe9cbf0": "Pipeline-Status ungültig",
  "E_c87684cb721a0e1d": "Studio nicht gefunden oder nicht aktiv",
  "E_c9873dfbbc671569": "Ruhezeitmodell nicht gefunden",
  "E_c9cbe763873631a3": "Offener Posten nicht gefunden",
  "E_ca52eb6d38c6d66b": "SFDT-Inhalt ist leer oder ungültig",
  "E_ccc1ffec07ddfe55": "Ruhezeitmodell wird noch verwendet und kann nicht gelöscht werden",
  "E_cd2f7b0a21cd2127": "Kein Zugriff",
  "E_cd5f4a82c84c4419": "Nachname zu lang",
  "E_cd9cae6d52874c35": "Ungültige Check-out-Zeit (5-1440 Minuten)",
  "E_ce0bbc3228e6b519": "Kürzel ist erforderlich und darf nicht leer sein.",
  "E_ce4b97ba06090071": "Innerhalb eines Gerätes dürfen keine doppelten QR-Codes verwendet werden.",
  "E_cec57cf02b830edc": "readerDeviceId oder userRoleId erforderlich",
  "E_cf6c1e7489df1b1d": "Für Guthabenzahlung dürfen nur Währungskonten gewählt werden.",
  "E_cf99aceaab18a622": "Passwort zu kurz",
  "E_cfe6a85cb264e4f3": "Ungültige Minutenangabe (0-1439)",
  "E_d0172c7c73dc62ff": "Offener Posten ist nicht offen",
  "E_d01f9a35abbe94c9": "Lastschriftlauf nicht gefunden",
  "E_d02d9329af833e50": "Eine der Terminarten wurde nicht gefunden oder ist inaktiv",
  "E_d0f90169e71be00c": "Mahnstufe nicht gefunden",
  "E_d2ab3b439686e967": "Pipeline wird noch von Leads verwendet und kann nicht gelöscht werden",
  "E_d2dbd55be2b016a7": "Die Vorlage wird von mindestens einem Vertrags-Widget verwendet und kann nicht gelöscht werden.",
  "E_d2e5a2c8654965ee": "Kein Zugriff auf die gewählte Ressource",
  "E_d32ee177bf84eb69": "SEPA-Datei wurde bereits heruntergeladen",
  "E_d39f9e3a5bfca17c": "Untergerät ist für Zuweisung deaktiviert",
  "E_d3e29ca0ebb6fe46": "Globale Feiertage werden im Admin-Bereich verwaltet. Bitte dort unter Einstellungen → Feiertagskalender importieren.",
  "E_d452c1916347eb67": "Mindestens ein Studio wurde nicht gefunden.",
  "E_d46c6bca70155ef5": "Vertragspaket ist bereits beendet und kann nicht zurückgenommen werden",
  "E_d4d954a4e1501da4": "Zahlungsdatum ist erforderlich.",
  "E_d50044ce94948654": "Keine Berechtigung für dieses Studio",
  "E_d53e90f1c87b0a8a": "Lauf ist bereits verbucht",
  "E_d556b559dc70dc31": "DOCX-Konvertierung ergab leeres Dokument",
  "E_d578ab0666f180b7": "Ungültiges JSON-Format",
  "E_d5e500b6ef25659e": "Ungültiger Benutzername",
  "E_d6220a0141fb98f9": "Terminart nicht gefunden oder nicht aktiv",
  "E_d697d273801c4181": "Bei eingeschränkter Auswahl mindestens eine Schnittstellen-Art wählen.",
  "E_d6d85e9a551106fd": "PersonId ist erforderlich",
  "E_d7aa82d2b3ce8855": "Admin-Einstellungen nicht gefunden",
  "E_d8bd2ad702f1dd25": "Port ungültig",
  "E_db25fea7d8ef1789": "Name required",
  "E_dbb00860d81891f0": "Bankverbindung nicht gefunden.",
  "E_dbcf10b2c22b0ddb": "Eine Zahlungsart mit diesem Typ existiert bereits.",
  "E_dc00713993b6c263": "SEPA-Gruppe nicht gefunden",
  "E_dc569bf46322e851": "Contribution is already paid",
  "E_dca08c873d29417f": "Body fehlt",
  "E_dcb916d8ef6088c2": "Die Stornofrist für Mitarbeiter-Stornierung ist überschritten",
  "E_dcc1c85d6d1b5462": "SFDT → DOCX Konvertierung fehlgeschlagen",
  "E_dcc3e69d0c6a83a1": "WalletProductId fehlt",
  "E_dd0a987e4b75927f": "Kündigungsmodell wird noch verwendet und kann nicht gelöscht werden",
  "E_dd154b1f575aab0a": "ReaderDeviceId fehlt",
  "E_dd1f5bba02fb6341": "Am Vertragspaket ist kein Ruhezeitmodell hinterlegt (weder Snapshot noch Vorlagen-ID).",
  "E_dd2c2ff26c179096": "Ungültige E-Mail",
  "E_ddb49ecfce0675dc": "Zahlungsart wird noch verwendet und kann nicht gelöscht werden",
  "E_de39847fdb159083": "Kein Scan empfangen (Timeout)",
  "E_de72b67da108713e": "Anzahl Beiträge darf nicht negativ sein",
  "E_dedfed022a8ec46c": "Stammstudio ist erforderlich",
  "E_dee77619cc64f091": "Monatliche Pauschale darf nicht negativ sein",
  "E_df847a54c928e6b8": "Keine Berechtigung",
  "E_e1c2f43d68c95661": "Vorlage mit diesem Namen und Kanal existiert bereits.",
  "E_e2059e74eae4a0db": "SEPA-Lastschrift aktivieren nicht möglich: Firmen-IBAN fehlt und es existiert keine Bankverbindung mit IBAN (Stammdaten → Bank).",
  "E_e4c6de54de954537": "Id 'admin' ist reserviert",
  "E_e4ce71dfa1993087": "Mitglied nicht gefunden oder kein Mitglied",
  "E_e4d7777ac367aeac": "Keine Berechtigung für eines der ausgewählten Studios",
  "E_e5ad9305329c9491": "Rabattwert ungültig",
  "E_e5ff3f4442ea9e54": "Enddatum muss nach Startdatum liegen",
  "E_e61003fc281b799b": "Vertragsdokument konnte nicht erzeugt werden. Bitte Logs prüfen.",
  "E_e6507a91fa0f441f": "Open item is not open",
  "E_e66bc89829343876": "Rundung: Endung muss >= 0 und < Schritt sein",
  "E_e6b8d16ed45f9547": "Betrag darf nicht 0 sein",
  "E_e7162c7de274b399": "Ungültiger Standard-Zeitraum (muss 60 Minuten bis max. Aufbewahrung sein)",
  "E_e7a397a1ff21bac0": "Standard-Konto für Wertekonten nicht gefunden",
  "E_e8388ed5c270cd00": "Das Beginndatum muss der Beginn einer vollen Zahlungsperiode sein.",
  "E_e8abaf56778eba51": "Maximal 140 Zeichen",
  "E_e8d3c655c694ade0": "Keine Berechtigung (Admin)",
  "E_e910e9bf71b4b3bc": "Vertragsbaustein kann nicht gelöscht werden, solange er in Vertragsvorlagen oder Kunden-Leistungen verwendet wird.",
  "E_e93d41ef66cb945a": "Vertragspaket-Vorlage nicht gefunden",
  "E_e946100c835653de": "Name zu lang (max. 200 Zeichen)",
  "E_e955ebe0ab8793bd": "ContractTemplateId fehlt",
  "E_ea77dab748ef95d7": "Balance ungültig",
  "E_ebc7cf04e06ae885": "Eine oder mehrere Textvorlagen decken nicht den vollständigen Studio-Bereich der Mahnstufe ab.",
  "E_ee1c157a7d2168e3": "Id required",
  "E_ee36ce0c1250429d": "Vorlage nicht gefunden",
  "E_ee539a38eca28acc": "Nur M1AccessRqr-Lesegeräte werden für Reverse-QR in der App unterstützt",
  "E_eeb4eef93c125fcb": "Löschen nicht möglich: Für diesen Vertrag wurden bereits Beiträge bezahlt.",
  "E_eed6facb006735a8": "Fehler beim Laden des Templates",
  "E_efd112b47aa1c5af": "Person hat keine E-Mail-Adresse.",
  "E_f065a29a8c333474": "SchemaJson ist kein gültiges JSON.",
  "E_f074c9dea7aec999": "System-Rollenname kann nicht geändert werden",
  "E_f0bd3af52094c9df": "Vertragspaket wurde nicht gekündigt",
  "E_f0d05d6d5cc68381": "Ungültige Zahlungsart",
  "E_f0e0aad840b05774": "Wertekonto-Produkt nicht gefunden",
  "E_f158e19be05392bc": "System-Rolle kann nicht gelöscht werden",
  "E_f498c5ccbbb73ca5": "MediumId required",
  "E_f4a82b8510b0d84d": "Kündigungsgebühr darf nicht negativ sein",
  "E_f4bcf5aaddadca1c": "Standard-Konto für Vertragsbausteine nicht gefunden",
  "E_f68ae5302f886633": "One or more selected studios are already assigned in another holiday scope. Each studio may only appear in one entry.",
  "E_f6f95351a2df92db": "Kündigungsfrist für Verlängerung darf nicht negativ sein",
  "E_f75cbd91cbe045e1": "mediumId fehlt",
  "E_f75f71eb0d1c60eb": "Channel muss 'letter' oder 'email' sein",
  "E_f7bc5c623832b04d": "Dokument nicht gefunden",
  "E_f808a6f8fbb09e87": "Ungültige Preferences (JSON fehlt)",
  "E_f8b8a648001769ac": "Anfragekörper fehlt",
  "E_f9b4dafe5e5acb31": "Der primäre Administrator-Account kann nicht deaktiviert werden.",
  "E_f9ee52c7ef6d4f64": "Passwort fehlt",
  "E_fab63d50328cd503": "Registrierungscode kann nur für m1connect-Geräte generiert werden.",
  "E_fabb0c3c39490964": "PipelineId erforderlich",
  "E_fad27d6c506c4b72": "PlanName darf nicht leer sein.",
  "E_fae23f4ebd8b1d9c": "StudioId erforderlich (oder resetDefault=true)",
  "E_fc9f249e77f5e027": "Mindestens ein aktiver Plattform-Administrator muss verbleiben.",
  "E_fd11adedcb679656": "Eine oder mehrere Ressourcen wurden nicht gefunden",
  "E_fd877f070fa7ac9c": "Ungültige Batch-Größe (1-500)",
  "E_fe04c2f8c0193755": "Für M1Access-RQR müssen genau 2 QR-Codes angegeben werden.",
  "E_fe999f8cb226a1f9": "Passwort ist erforderlich",
  "E_ff2d49183eaca660": "Aktive Pipeline: Endphasen benötigen zugeordnete Abschlussgründe — Abschlussgründe zuordnen oder die Pipeline zuerst deaktivieren",
  "E_ff7410c5434cbf48": "Token ungültig oder abgelaufen",
  "E_DOCUMENT_RENDER_FAILED": "Das Dokument konnte nicht erzeugt werden.",
  "E_DOCUMENT_RENDER_TIMEOUT": "Die Erzeugung des Dokuments hat zu lange gedauert. Bitte erneut versuchen.",
  "E_DOCUMENT_RENDER_NOT_READY": "Die Schriften werden noch geladen. Bitte in wenigen Sekunden erneut versuchen.",
} as const;
